<template>
  <sidebar-item
    v-if="hasDarkKitchen"
    :link="{
      name: copy.moduleName,
      icon: 'ni ni-book-bookmark text-success',
      path: basePath
    }"
  />
</template>

<script>
import { MANUAL_BASE_PATH, MANUAL_COPY } from '@/components/OperationsManual/manualCopy';

export default {
  name: 'OperationsManualLink',
  data() {
    return { copy: MANUAL_COPY, basePath: MANUAL_BASE_PATH };
  },
  computed: {
    hasDarkKitchen() {
      return this.$store.getters.getKitchenId !== null;
    }
  }
};
</script>
